import './AudioProcessingLoader.css';

import React from 'react';

const AudioProcessingLoader = ({ text = "Processing..." }) => {
  return (
    <div className="audio-processing-loader">
      <div className="loader-spinner"></div>
      <span className="loader-text">{text}</span>
    </div>
  );
};

export { AudioProcessingLoader };